import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import { CONTACT_PAGE_URL } from '../../utils/Routes';
// Components
import HomeAboutContainer from './HomeAboutContainer';
import SessionsComponent from './SessionsComponent';
import CardsAndBearDisplay from './CardsAndBearDisplay';
import CallToActionOne from '../cta/CallToActionOne';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
import HomeReviewSection from '../reviews/HomeReviewSection';
import EyeBanner from '../banners/EyeBanner';

function HomePageMainContainer() {
  return (
    <main id='main-content' role='main' className='grid w-full h-full pt-24'>
      <HomeAboutContainer />

      <SessionsComponent />

      <CallToActionOne />

      <CardsAndBearDisplay />

      <div className='grid justify-center py-12'>
        <Link
          to={CONTACT_PAGE_URL}
          className={`cursor-pointer hover:bg-colour5/50 border-2 border-solid border-colour6 bg-black w-full text-center h-fit px-10 md:px-2 lg:px-6 py-2 rounded mx-auto`}
          aria-label={`Contact page link`}
        >
          Book A Session
        </Link>
      </div>

      <EyeBanner />
      <HomeReviewSection />

      <SocialMediaCtaComponent />
    </main>
  );
}

export default HomePageMainContainer;
